// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

const S = {
  ErrorMessage: styled.div`
    font-size: 14px;
    line-height: 20px;
    color: #FE4747;
    margin-top: 5px;
  `,
  Container: styled.div<{error:boolean, isFilled:boolean}>`
    position: relative;
    background: #FFFFFF;
    ${props => props.error ? 'border: 1px solid #FE4747;' : props.isFilled ? 'border: 1px solid #434343;':'border: 1px solid #DEDEDE;'}
    box-sizing: border-box;
    border-radius: 4px;
    display: flex;
    flex-grow:1;
    max-width: 366px;
    height: 55px;
    padding: 0 12px 0 21px;
    justify-content: center;
    flex-direction: column;
  `,
  Input: styled.input`
    width: 100%;
    &::placeholder {
      font-size: 16px;
      line-height: 23px;
      color: #C9C9C9;
    }

    &::-ms-reveal,
    &::-ms-clear {
      display: none;
    }
  `,
  Label: styled.div<{error:boolean}>`
    position: absolute;
    background: #FFFFFF;
    font-size: 12px;
    line-height: 17px;
    ${props => props.error ? 'color: #FE4747;' : 'color: #666666;'}
    top: -10px;
    padding-left: 5px;
    padding-right: 5px;
    display: flex;
    justify-content: center;
  `,
  ShowPassword: styled.img`
    cursor: pointer;
  `,
  InputContainer: styled.div`
    display: inline-flex;
  `,
};

export { S as default };
